import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Formik
import { Formik, Form, Field } from 'formik';
import * as yup from 'yup';

// Material Kit 2 React components
import MKBox from "../../../components/MaterialKit/MKBox";
import MKTypography from "../../../components/MaterialKit/MKTypography";
import MKInput from "../../../components/MaterialKit/MKInput";
import MKNumberInput from "../../../components/MaterialKit/MKInput/MKNumberInput";
import MKMoneyInput from "../../../components/MaterialKit/MKInput/MKMoneyInput";
import MKAutoSuggest from "../../../components/MaterialKit/MKInput/MKAutoSuggest";
import MKButton from "../../../components/MaterialKit/MKButton";


const validationSchema = yup.object({
  businessName: yup.string()
    .required("All fields are required"),
  businessType: yup.string()
    .required("All fields are required"),
  businessInvolved: yup.string()
    .required("All fields are required"),
  noEmployees: yup.string()
    .required("All fields are required"),
  turnover: yup.string()
    .required("All fields are required"),
  yearsActive: yup.number().typeError('A valid period in years is required')
    .min(0, "A valid positive number is required")
    .max(200, "Are you sure your business have been active for this long?")
    .required("All fields are required"),
});
function Step1(props) {

  const [stepValues, setStepValues] = useState({
    businessName: "",
    businessType: "",
    businessInvolved: "",
    noEmployees: "",
    turnover: "",
    yearsActive: ""
  });


  useEffect(() => {
    let cancel = false;
    if (cancel)
      return;

    if (props.step1Values) {
      setStepValues(props.step1Values);
    }

    return () => {
      cancel = true;
    }
  }, [props.step1Values])

  useEffect(() => {
    let cancel = false;
    if (cancel)
      return;


    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    props.setPercentage(0);
    props.setCurrentStepName("Company Information");
    props.setNextStepName("Personal Information");

    return () => {
      cancel = true;
    }
  }, [props]);

  const businessTypes = [
    "Sole Proprietorship",
    "Partnership",
    "Close Corporation (CC)",
    "Public Company",
    "Private Company"

  ];

  return (
    <>
      <MKBox component="section" p={2} method="post">
        <MKBox px={3} py={{ xs: 2, sm: 6 }}>
          <MKTypography variant="h2" mb={1}>
            Tell us about your business
          </MKTypography>
        </MKBox>
        <MKBox pt={0.5} pb={3} px={3}>
          <Formik
            enableReinitialize={true}
            initialValues={stepValues}
            validationSchema={validationSchema}
            onSubmit={values => {
              props.setStep1Values(values);
              props.setCurrentStep(2);
            }
            }
          >
            {(props) => (
              <Form>
                <Grid container spacing={1} alignItems="center" sx={{ textAlign: "center" }}>
                  <Grid item xs={12}>
                    <MKInput
                      label="Name of the business"
                      id="businessName"
                      value={props.values.businessName}
                      onChange={props.handleChange('businessName')}
                      error={props.errors.businessName && Boolean(props.errors.businessName)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field name="businessType">
                      {({ field, form, meta }) => (
                        <MKAutoSuggest
                          label="Type of business"
                          options={businessTypes}
                          minSearchLength={0}
                          freeSolo={false}

                          value={field.value || ""}

                          onChange={(newValue, reason) => {
                            form.setFieldValue(field.name, newValue);
                          }}

                          onBlur={() => form.setFieldTouched(field.name, true)}

                          error={meta.touched && Boolean(meta.error)}
                          fullWidth
                        />
                      )}
                    </Field>
                  </Grid>
                  <Grid item xs={12}>
                    <MKInput
                      label="Trade or nature of business"
                      id="businessInvolved"
                      value={props.values.businessInvolved}
                      onChange={props.handleChange('businessInvolved')}
                      error={props.errors.businessInvolved && Boolean(props.errors.businessInvolved)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      name="noEmployees">
                      {({ field, form: { touched, errors } }) => (
                        <MKNumberInput
                          label="Number of employees"
                          id="noEmployees"
                          allowLeadingZeros={false}
                          decimalScale={0}
                          value={field.value}
                          onRawValueChange={value => props.setFieldValue('noEmployees', value)}
                          error={touched.noEmployees && Boolean(errors.noEmployees)}
                          fullWidth
                        />
                      )}
                    </Field>
                  </Grid>
                  <Grid item xs={12}>
                    <MKMoneyInput
                      label="Turnover (ZAR)"
                      id="turnover"
                      value={props.values.turnover}
                      onRawValueChange={(floatValue) => {
                        props.setFieldValue('turnover', floatValue);
                      }}
                      error={props.errors.turnover && Boolean(props.errors.turnover)}
                      decimalScale={0}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Field
                      name="yearsActive">
                      {({ field, form: { touched, errors } }) => (
                        <MKNumberInput
                          label="Years active"
                          id="yearsActive"
                          allowLeadingZeros={false}
                          decimalScale={0}
                          value={field.value}
                          onRawValueChange={value => props.setFieldValue('yearsActive', value)}
                          error={touched.yearsActive && Boolean(errors.yearsActive)}
                          fullWidth
                        />
                      )}
                    </Field>
                  </Grid>
                  <Grid item xs={12}>
                    <MKTypography variant="caption" color="error" align="center">
                      {props.errors.businessName && props.errors.businessName}
                      {!props.errors.businessName && props.errors.businessType && props.errors.businessType}
                      {!props.errors.businessName && !props.errors.businessType && props.errors.businessInvolved && props.errors.businessInvolved}
                      {!props.errors.businessName && !props.errors.businessType && !props.errors.businessInvolved && props.errors.yearsActive && props.errors.yearsActive}
                    </MKTypography>
                  </Grid>
                  <Grid item xs={6} sx={{ textAlign: "left" }}>
                    <MKButton type="button" href="/our-offering/legal-cover/commercial-legal-cover" variant="gradient" color="light" sx={{ height: "100%" }}>
                      Back
                    </MKButton>
                  </Grid>
                  <Grid item xs={6} sx={{ textAlign: "right" }}>
                    <MKButton type="submit" variant="gradient" color="info" sx={{ height: "100%" }}>
                      Next
                    </MKButton>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </MKBox>
      </MKBox>
    </>
  );
}

export default Step1;